import { useState } from "react";
import { CgSpinner } from "react-icons/cg";
import { IoMdClose } from "react-icons/io";
import { useDispatch, useSelector } from "react-redux";
import nodeinstance from "../../../../../nodeInstance";
import { setAppError } from "../../../../../store/userSlice";
import React from "react";
import DropDownList from "../../../../../ReusableComponents/DropDownList/DropDownList";

export default function DemobilizationPopup({
  PopUp,
  setPopUp,
  callBack,
  empid,
  editfunctionality,
  searchResponse,
}) {
  const token = localStorage.getItem("nodeToken");
  const [formData, setFormData] = useState({
    demobilizationDate: "",
    demobilizationType: "",
    comment: "",
  });
  console.log("empid.........", empid);
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);

  const [error, setError] = useState(false);

  const submitHandler = async () => {
    console.log("emp...............................", empid);
    if (formData.demobilizationDate === "") {
      dispatch(
        setAppError({
          msg: "Demobilization date is required",
          color: "bg-green-700",
        })
      );
      return;
    }
    if (!editfunctionality && formData.demobilizationType === "") {
      dispatch(
        setAppError({
          msg: "Demobilization type is required",
          color: "bg-green-700",
        })
      );
      return;
    }
    if (!editfunctionality && formData.comment === "") {
      dispatch(
        setAppError({
          msg: "Comments required",
          color: "bg-green-700",
        })
      );
      return;
    }
    let reqObject;
    if (editfunctionality) {
      reqObject = empid
        .filter(
          (fil) =>
            new Date(formData.demobilizationDate) >
            new Date(fil.item.mobilization_date)
        )
        .map((data, i) => {
          return {
            employee_id: data.employee_id,
            demobilization_date: formData.demobilizationDate,
          };
        });
    } else {
      reqObject = empid
        .filter(
          (fil) =>
            new Date(formData.demobilizationDate) >
            new Date(fil.item.mobilization_date)
        )
        .map((data, i) => {
          return {
            employee_id: data.employee_id,
            demobilization_date: formData.demobilizationDate,
            demobilization_type: formData.demobilizationType,
            demobilization_comments: formData.comment,
          };
        });
    }
    if (reqObject.length <= 0) {
      dispatch(
        setAppError({
          msg: "No employee updated.",
          // color: "bg-green-700",
        })
      );
      return;
    }
    console.log("reqobject to be printed in the console", formData, empid);
    // // console.log("Data to be printed in the console", reqObject);
    // setLoading(true);
    const url = editfunctionality
      ? `/demobilization/changedemobilizedate`
      : `/demobilization/demobilize`;
    try {
      const response = await nodeinstance.put(`${url}`, reqObject, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (response.status === 200) {
        setLoading(false);
        dispatch(
          setAppError({
            msg: response.data.message,
            color: "bg-green-700",
          })
        );
        setPopUp(false);

        callBack();
      } else {
        dispatch(
          setAppError({
            msg: response.data.message,
          })
        );
      }
    } catch (err) {
      setError(err);
      setLoading(false);
      console.log("error", err);
    }
  };

  var list = [
    { value: "IDLE" },
    { value: "ERE-EMERGENCY LEAVE" },
    { value: "ERE-ANNUAL VACATION" },
    { value: "ABSCONDING-RUN AWAY" },
    { value: "TERMINATION-FINAL EXIT" },
    { value: "RESIGNATION-FINAL EXIT" },
    { value: "NAKAL KAFALA-FINAL EXIT" },
  ];
  const statusValue = (event) => {
    setFormData({
      ...formData,
      demobilizationType: event.target.value,
    });
  };
  console.log("searchResponse.....searchResponse", searchResponse);
  return (
    <>
      <div
        className={`fixed z-50 top-0 left-0 min-w-full min-h-screen bg-black/50  justify-center items-center ${
          PopUp ? "flex" : "hidden"
        }`}
      >
        <div className="max-w-lg w-full h-auto   rounded-md bg-white/95 flex  flex-col p-4 relative m-2">
          {editfunctionality ? (
            ""
          ) : (
            <>
              <div className="form-control w-full">
                <label className="label">
                  <span className="label-text">DEMOBILIZATION TYPE</span>
                </label>
                <DropDownList setValue={statusValue} presetValues={list} />
              </div>
            </>
          )}
          <div className="form-control w-full mt-3">
            <label className="label">
              <span className="label-text">DEMOBILIZATION DATE</span>
            </label>
            <input
              type="Date"
              value={formData.demobilizationDate}
              className="input input-sm input-bordered"
              required
              disabled={
                !editfunctionality && formData.demobilizationType === ""
              }
              onChange={(e) =>
                setFormData({
                  ...formData,
                  demobilizationDate: e.target.value,
                })
              }
              onKeyDown={(e) => e.preventDefault()}
            />
          </div>
          {editfunctionality ? (
            ""
          ) : (
            <>
              <div className="form-control w-full">
                <label className="label">
                  <span className="label-text">Comment</span>
                </label>
                <textarea
                  id="paragraph"
                  value={formData.contractnumber}
                  placeholder="Enter your Comments Here"
                  type="text"
                  rows={4}
                  cols={30}
                  className="textarea input-bordered"
                  required
                  onChange={(e) =>
                    setFormData({
                      ...formData,
                      comment: e.target.value,
                    })
                  }
                />
              </div>
            </>
          )}
          <div className="w-full">
            <div className="w-full flex flex-col gap-3 my-3 p-5">
              <div className="flex gap-3 w-full justify-center">
                <button
                  className="p-3 bg-blue text-white rounded-md w-full max-w-xs m-2 my-4 flex gap-3 justify-center items-center text-sm"
                  onClick={() => {
                    setPopUp(false);
                  }}
                >
                  <p>Cancel</p>
                </button>

                <button
                  className="p-3 bg-red text-white rounded-md w-full max-w-xs m-2 my-4 flex gap-3 justify-center items-center text-sm"
                  onClick={() => submitHandler()}
                >
                  <p>Submit</p>
                  {loading ? <CgSpinner className="animate-spin" /> : ""}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
